import { createContext, useState, useEffect } from "react";
import { DEFAULT_THEME, DEFAULT_COLOR } from "../lib/constants";
import { todayStr } from "../lib/dateUtils";
import {
  GiHummingbird,
  GiLion,
  GiBearFace,
  GiWhaleTail,
  GiButterfly,
  GiTigerHead,
  GiDolphin,
  GiGorilla,
  GiBurningSkull,
  GiSharkFin,
  GiSharkJaws,
} from "react-icons/gi";

const AppContext = createContext({});

const HABIT_COLORS = [
  "#e74c3c", "#3498db", "#2ecc71", "#f39c12", "#9b59b6",
  "#1abc9c", "#e91e63", "#ff5722", "#00bcd4", "#8bc34a",
];

export const AppProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    color: localStorage.getItem("color") || DEFAULT_COLOR,
    theme: localStorage.getItem("theme") || DEFAULT_THEME,
  });

  const [habits, setHabits] = useState(
    () => JSON.parse(localStorage.getItem("habits")) || []
  );

  const themes = {
    hummingbird: GiHummingbird,
    lion: GiLion,
    bear: GiBearFace,
    whale: GiWhaleTail,
    butterfly: GiButterfly,
    tiger: GiTigerHead,
    dolphin: GiDolphin,
    gorilla: GiGorilla,
    skull: GiBurningSkull,
    shark1: GiSharkFin,
    shark2: GiSharkJaws,
  };

  useEffect(() => {
    localStorage.setItem("theme", settings.theme);
    localStorage.setItem("color", settings.color);
  }, [settings]);

  useEffect(() => {
    localStorage.setItem("habits", JSON.stringify(habits));
  }, [habits]);

  const addHabit = (name) => {
    const id = Date.now().toString();
    const color = HABIT_COLORS[habits.length % HABIT_COLORS.length];
    setHabits((prev) => [
      ...prev,
      { id, name, color, createdAt: todayStr(), entries: {} },
    ]);
  };

  const deleteHabit = (id) => {
    setHabits((prev) => prev.filter((h) => h.id !== id));
  };

  // Cycles: unmarked → done → missed → unmarked
  const toggleEntry = (habitId, dateStr) => {
    setHabits((prev) =>
      prev.map((habit) => {
        if (habit.id !== habitId) return habit;
        const current = habit.entries[dateStr];
        const entries = { ...habit.entries };
        if (current === undefined) entries[dateStr] = "done";
        else if (current === "done") entries[dateStr] = "missed";
        else delete entries[dateStr];
        return { ...habit, entries };
      })
    );
  };

  return (
    <AppContext.Provider
      value={{ settings, setSettings, themes, habits, addHabit, deleteHabit, toggleEntry }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
